<template>
  <v-card class="d-flex pa-2 flex-column" outlined>
    <v-alert
      v-model="flashError"
      dense
      border="left"
      type="error"
      dismissible
      elevation="2"
    >
      {{ flashErrorMessage }}
    </v-alert>
    <v-data-table
      :headers="headers"
      fixed-header
      :items="allData"
      :options.sync="options"
      :server-items-length="totalData"
      :loading="loading"
      loading-text="Loading... Please wait"
      :item-class="rowClass"
      class="d-print-table"
      :footer-props="{
        itemsPerPageOptions: [5, 10, 25, 50],
        // showFirstLastPage: true,
      }"
      item-key="trx_id"
      sort-by="trx_date"
      :sort-desc="true"
      :style="{ padding: '10px', height: '70vh' }"
    >
      <template v-slot:[`body.prepend`]>
        <tr>
          <td
            class="pa-3 d-block d-sm-table-cell d-print-table-cell fixed-row"
          />
          <td class="pa-3 d-block d-sm-table-cell d-print-table-cell fixed-row">
            <v-text-field
              v-model="search.aggregator_name"
              type="text"
              label="Agregator Name"
              v-on:keyup.enter="getData"
              hide-details="true"
              dense
              prepend-inner-icon="mdi-magnify"
            />
          </td>
          <td class="pa-3 d-block d-sm-table-cell d-print-table-cell fixed-row">
            <v-text-field
              v-model="search.bill_num"
              type="text"
              label="Bill Number"
              v-on:keyup.enter="getData"
              hide-details="true"
              dense
              prepend-inner-icon="mdi-magnify"
            />
          </td>
          <td class="pa-3 d-block d-sm-table-cell d-print-table-cell fixed-row">
            <v-text-field
              v-model="search.merchant_name"
              type="text"
              label="Merchant Name"
              v-on:keyup.enter="getData"
              hide-details="true"
              dense
              prepend-inner-icon="mdi-magnify"
            />
          </td>
          <td class="pa-3 d-block d-sm-table-cell d-print-table-cell fixed-row">
            <v-text-field
              v-model="search.mid"
              type="text"
              label="MID"
              v-on:keyup.enter="getData"
              hide-details="true"
              dense
              prepend-inner-icon="mdi-magnify"
            />
          </td>
          <td class="pa-3 d-block d-sm-table-cell d-print-table-cell fixed-row">
            <v-text-field
              v-model="search.merchant_pan"
              type="text"
              label="Merchant PAN"
              v-on:keyup.enter="getData"
              hide-details="true"
              dense
              prepend-inner-icon="mdi-magnify"
            />
          </td>
          <td class="pa-3 d-block d-sm-table-cell d-print-table-cell fixed-row">
            <v-text-field
              v-model="search.reff_id"
              type="text"
              label="Reff ID"
              v-on:keyup.enter="getData"
              hide-details="true"
              dense
              prepend-inner-icon="mdi-magnify"
            />
          </td>
          <td class="pa-3 d-block d-sm-table-cell d-print-table-cell fixed-row">
            <v-text-field
              v-model="search.customer_pan"
              type="text"
              label="Customer PAN"
              v-on:keyup.enter="getData"
              hide-details="true"
              dense
              prepend-inner-icon="mdi-magnify"
            />
          </td>
          <td class="pa-3 d-block d-sm-table-cell d-print-table-cell fixed-row">
            <v-text-field
              v-model="search.customer_name"
              type="text"
              label="Nama Customer"
              v-on:keyup.enter="getData"
              hide-details="true"
              dense
              prepend-inner-icon="mdi-magnify"
            />
          </td>
          <td class="pa-3 d-block d-sm-table-cell d-print-table-cell fixed-row">
            <v-select
              v-model="search.qr_method"
              :items="listQrType"
              label="QR Method"
              item-text="text"
              item-value="value"
              clearable
              hide-details="true"
              dense
            />
          </td>
          <td class="pa-3 d-block d-sm-table-cell d-print-table-cell fixed-row">
            <v-select
              v-model="search.qr_tipe"
              :items="listQrType"
              label="Tipe QR"
              item-text="text"
              item-value="value"
              clearable
              hide-details="true"
              dense
            />
          </td>
          <td class="pa-3 d-block d-sm-table-cell d-print-table-cell fixed-row">
            <v-select
              v-model="search.qr_tipe"
              :items="listQrType"
              label="Tipe Transaksi"
              item-text="text"
              item-value="value"
              clearable
              hide-details="true"
              dense
            />
          </td>
          <td class="pa-3 d-block d-sm-table-cell d-print-table-cell fixed-row">
            <v-select
              v-model="search.nama_issuer"
              :items="listQrType"
              label="Nama Issuer"
              item-text="text"
              item-value="value"
              clearable
              hide-details="true"
              dense
            />
          </td>
          <td class="pa-3 d-block d-sm-table-cell d-print-table-cell fixed-row">
            <v-select
              v-model="search.jenis_pembayaran"
              :items="listQrType"
              label="Jenis Pembayaran"
              item-text="text"
              item-value="value"
              clearable
              hide-details="true"
              dense
            />
          </td>
          <td class="pa-3 d-block d-sm-table-cell d-print-table-cell fixed-row">
            <v-select
              v-model="search.nama_acquirer"
              :items="listQrType"
              label="Nama Acquirer"
              item-text="text"
              item-value="value"
              clearable
              hide-details="true"
              dense
            />
          </td>
          <td
            class="pa-3 d-block d-sm-table-cell d-print-table-cell fixed-row"
          />
          <td
            class="pa-3 d-block d-sm-table-cell d-print-table-cell fixed-row"
          />
          <td
            class="pa-3 d-block d-sm-table-cell d-print-table-cell fixed-row"
          />
          <td
            class="pa-3 d-block d-sm-table-cell d-print-table-cell fixed-row"
          />
          <td class="pa-3 d-block d-sm-table-cell d-print-table-cell fixed-row">
            <v-select
              v-model="search.status_trx"
              :items="listQrType"
              label="Status"
              item-text="text"
              item-value="value"
              clearable
              hide-details="true"
              dense
            />
          </td>
          <td class="pa-3 d-block d-sm-table-cell d-print-table-cell fixed-row">
            <v-select
              v-model="search.setlement_status"
              :items="listQrType"
              label="Setlement Status"
              item-text="text"
              item-value="value"
              clearable
              hide-details="true"
              dense
            />
          </td>
        </tr>
      </template>
      <template v-slot:top>
        <v-toolbar flat>
          <template>
            <v-dialog
              ref="rangeDateDialog"
              v-model="rangeDateDialog"
              :return-value.sync="filter.trx_datetime"
              persistent
              max-width="290px"
              min-width="290px"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                  id="rangeDate"
                  prepend-inner-icon="mdi-calendar"
                  readonly
                  v-bind="attrs"
                  v-on="on"
                  v-model="dateRangeText"
                  label="Transaction Date"
                  hide-details="true"
                >
                  <template v-slot:append-outer>
                    <v-btn large text color="orange" @click="showData">
                      <v-icon left> mdi-magnify </v-icon>search
                    </v-btn>
                  </template>
                </v-text-field>
              </template>
              <v-date-picker
                v-model="filter.trx_date"
                scrollable
                range
                :min="minDate"
                :max="maxDate"
              >
                <v-spacer />
                <v-btn text color="primary" @click="rangeDateDialog = false">
                  Cancel
                </v-btn>
                <v-btn
                  text
                  color="primary"
                  @click="
                    () => {
                      checkRangeDate();
                      $refs.rangeDateDialog.save(filter.trx_date);
                    }
                  "
                >
                  OK
                </v-btn>
              </v-date-picker>
            </v-dialog>
          </template>

          <v-spacer />
          <v-dialog v-model="dialog" max-width="500px">
            <v-card>
              <v-form>
                <v-card-title>
                  <span class="headline">Detail Report EDC</span>
                </v-card-title>

                <v-card-text>
                  <v-container>
                    <data-detail-row
                      label="Aggregator Name"
                      :data="editedItem"
                      :valueData="editedItem.aggregator_name"
                      noGutters
                    />
                    <data-detail-row
                      label="Bill Number"
                      :data="editedItem"
                      :valueData="editedItem.bill_num"
                      noGutters
                    />
                    <data-detail-row
                      label="Merchant Name"
                      :data="editedItem"
                      :valueData="editedItem.merchant_name"
                      noGutters
                    />
                    <data-detail-row
                      label="MID"
                      :data="editedItem"
                      :valueData="editedItem.mid"
                      noGutters
                    />
                    <data-detail-row
                      label="Merchant PAN"
                      :data="editedItem"
                      :valueData="editedItem.issuer_name"
                      noGutters
                    />
                    <data-detail-row
                      label="Reff ID"
                      :data="editedItem"
                      :valueData="editedItem.reff_ID"
                      noGutters
                    />
                    <data-detail-row
                      label="Customer PAN"
                      :data="editedItem"
                      :valueData="editedItem.acquirer_name"
                      noGutters
                    />
                    <data-detail-row
                      label="Nama Customer"
                      :data="editedItem"
                      :valueData="editedItem.amount"
                      noGutters
                    />
                    <data-detail-row
                      label="QR Method"
                      :data="editedItem"
                      :valueData="editedItem.mdr_fee"
                      noGutters
                    />
                    <data-detail-row
                      label="Tipe QR"
                      :data="editedItem"
                      :valueData="editedItem.net_amount"
                      noGutters
                    />
                    <data-detail-row
                      label="Tipe Transaction"
                      :data="editedItem"
                      :valueData="editedItem.net_amount"
                      noGutters
                    />
                    <data-detail-row
                      label="Nama Issuer"
                      :data="editedItem"
                      :valueData="editedItem.trx_date"
                      noGutters
                    />
                    <data-detail-row
                      label="Jenis Payment"
                      :data="editedItem"
                      :valueData="editedItem.status"
                      noGutters
                    />
                    <data-detail-row
                      label="Nama Acquirer"
                      :data="editedItem"
                      :valueData="editedItem.settlement_status"
                      noGutters
                    />
                    <data-detail-row
                      label="Nominal"
                      :data="editedItem"
                      :valueData="editedItem.sof"
                      noGutters
                    />
                    <data-detail-row
                      label="Amount MDR"
                      :data="editedItem"
                      :valueData="editedItem.proc_date"
                      noGutters
                    />
                    <data-detail-row
                      label="Net Amount"
                      :data="editedItem"
                      :valueData="editedItem.gb"
                      noGutters
                    />
                    <data-detail-row
                      label="TRX Datetime"
                      :data="editedItem"
                      :valueData="editedItem.ob"
                      noGutters
                    />
                    <data-detail-row
                      label="Status"
                      :data="editedItem"
                      :valueData="editedItem.seq"
                      noGutters
                    />
                    <data-detail-row
                      label="Setlement Status"
                      :data="editedItem"
                      :valueData="editedItem.type"
                      noGutters
                    />
                  </v-container>
                </v-card-text>

                <v-card-actions>
                  <v-spacer />
                  <v-btn color="blue darken-1" text @click="close">
                    Cancel
                  </v-btn>
                </v-card-actions>
              </v-form>
            </v-card>
          </v-dialog>
          <template>
            <v-btn
              color="warning"
              class="mb-2"
              @click="getData"
              :loading="loading"
              :disabled="loading"
              :style="{ 'margin-right': '10px' }"
              ><v-icon>mdi-restart</v-icon></v-btn
            >
            <v-menu
              offset-y
              rounded="lg"
              transition="slide-y-transition"
              bottom
              left
            >
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  color="warning"
                  class="mb-2"
                  icon
                  dark
                  v-bind="attrs"
                  v-on="on"
                >
                  <v-icon light size="20">mdi-dots-vertical</v-icon>
                </v-btn>
              </template>
              <v-list dense>
                <v-list-item link @click="exportItem()">
                  <v-list-item-icon>
                    <v-icon>mdi-file-excel</v-icon>
                  </v-list-item-icon>
                  <v-list-item-title>Export to excel</v-list-item-title>
                </v-list-item>
              </v-list>
            </v-menu>
          </template>
        </v-toolbar>
      </template>
      <template v-slot:item="{ item, index }">
        <tr
          :key="index"
          :style="{ cursor: 'pointer' }"
          :class="selectedRow == index ? 'indigo lighten-5' : ''"
          @click="selectRow(index)"
        >
          <td class="d-block d-sm-table-cell d-print-table-cell">
            {{ (options.page - 1) * options.itemsPerPage + index + 1 }}
          </td>
          <td class="d-block d-sm-table-cell d-print-table-cell">
            {{ item.aggregator_name }}
          </td>
          <td class="d-block d-sm-table-cell d-print-table-cell">
            {{ item.bill_num }}
          </td>
          <td class="d-block d-sm-table-cell d-print-table-cell">
            {{ item.merchant_name }}
          </td>
          <td class="d-block d-sm-table-cell d-print-table-cell">
            {{ item.mid }}
          </td>
          <td class="d-block d-sm-table-cell d-print-table-cell">
            {{ item.merchcant_pan }}
          </td>
          <td class="d-block d-sm-table-cell d-print-table-cell">
            {{ item.rrn }}
          </td>
          <td class="d-block d-sm-table-cell d-print-table-cell">
            {{ item.customer_pan }}
          </td>
          <td class="d-block d-sm-table-cell d-print-table-cell">
            {{ item.customer_name }}
          </td>
          <td class="d-block d-sm-table-cell d-print-table-cell">
            {{ item.qr_method }}
          </td>
          <td class="d-block d-sm-table-cell d-print-table-cell">
            {{ item.qr_type }}
          </td>
          <td class="d-block d-sm-table-cell d-print-table-cell">
            {{ item.trx_type }}
          </td>
          <td class="d-block d-sm-table-cell d-print-table-cell">
            {{ item.payment_method }}
          </td>
          <td class="d-block d-sm-table-cell d-print-table-cell">
            {{ item.issuer_name }}
          </td>
          <td class="d-block d-sm-table-cell d-print-table-cell">
            {{ item.payment_type }}
          </td>
          <td class="d-block d-sm-table-cell d-print-table-cell">
            {{ item.acquirer_name }}
          </td>
          <td class="d-block d-sm-table-cell d-print-table-cell">
            {{ item.amount }}
          </td>
          <td class="d-block d-sm-table-cell d-print-table-cell">
            {{ item.amount_mdr }}
          </td>
          <td class="d-block d-sm-table-cell d-print-table-cell">
            {{ item.net_amount }}
          </td>
          <td class="d-block d-sm-table-cell d-print-table-cell">
            {{ item.trx_datetime }}
          </td>
          <td class="d-block d-sm-table-cell d-print-table-cell">
            {{ item.status }}
          </td>
          <td class="d-block d-sm-table-cell d-print-table-cell">
            {{ item.setlement_status }}
          </td>
          <td class="d-block d-sm-table-cell d-print-table-cell">
            <v-icon small class="mr-2" @click="viewItem(item.trx_id)">
              mdi-eye
            </v-icon>
          </td>
        </tr>
      </template>
      <template v-slot:no-data>
        <v-btn color="primary" @click="clearSearch"> Reset </v-btn>
      </template>
    </v-data-table>
  </v-card>
</template>

<script>
import { dataMinRangeDate, dataMaxRangeDate } from '../../store/params';
import { getDate, date, showAlert } from '../../lib/helpers';

export default {
  components: {
    DataDetailRow: () => import('../../components/detail/DataDetailRow.vue'),
  },
  data: () => ({
    today: new Date(Date.now() - new Date().getTimezoneOffset() * 60000)
      .toISOString()
      .slice(0, 10),
    isFirstLoad: true,
    rangeDateDialog: false,
    options: {},
    view: false,
    show: false,
    dialog: false,
    expanded: [],
    headers: [
      {
        text: 'No',
        align: 'start',
        value: 'trx_id',
        sortable: false,
        width: '10',
      },
      {
        text: 'Agregator Name',
        value: 'aggregator_name',
        width: '150',
        align: 'center',
        sortable: false,
      },
      {
        text: 'Bill Number',
        value: '',
        width: '150',
        align: 'center',
        sortable: false,
      },
      {
        text: 'Merchant Name',
        value: 'merchant_name',
        width: '150',
        align: 'center',
        sortable: false,
      },
      {
        text: 'MID',
        value: 'mid',
        width: '150',
        sortable: false,
        align: 'center',
      },
      {
        text: 'Merchant PAN',
        value: '',
        width: '150',
        sortable: false,
        align: 'center',
      },
      {
        text: 'Reff ID',
        value: '',
        width: '150',
        sortable: false,
        align: 'center',
      },
      {
        text: 'Customer PAN',
        value: '',
        width: '150',
        sortable: false,
        align: 'center',
      },
      {
        text: 'Nama Customer',
        value: '',
        width: '150',
        sortable: false,
        align: 'center',
      },
      {
        text: 'QR Method',
        value: '',
        width: '150',
        sortable: false,
        align: 'center',
      },
      {
        text: 'Tipe QR',
        value: '',
        width: '150',
        align: 'center',
        sortable: false,
      },
      {
        text: 'Tipe Transaksi',
        value: '',
        width: '100',
        align: 'center',
        sortable: false,
      },
      {
        text: 'Nama Issuer',
        value: '',
        width: '180',
        align: 'center',
        sortable: false,
      },
      {
        text: 'Jenis Pembayaran',
        value: '',
        width: '180',
        align: 'center',
        sortable: false,
      },
      {
        text: 'Nama Acquirer',
        value: '',
        width: '180',
        align: 'center',
        sortable: false,
      },
      {
        text: 'Nominal',
        value: '',
        width: '150',
        align: 'center',
        sortable: false,
      },
      {
        text: 'Amount MDR',
        value: '',
        width: '150',
        align: 'center',
        sortable: false,
      },
      {
        text: 'Net Amount',
        value: '',
        width: '150',
        align: 'center',
        sortable: false,
      },
      {
        text: 'TRX Datetime',
        value: '',
        width: '150',
        align: 'center',
        sortable: false,
      },
      {
        text: 'Status',
        value: 'sof',
        width: '150',
        align: 'center',
        sortable: false,
      },
      {
        text: 'Setlement Status',
        value: 'sof',
        width: '150',
        align: 'center',
        sortable: false,
      },

      {
        text: 'Action',
        value: 'actions',
        sortable: false,
      },
    ],
    filter: {
      trx_date: [],
    },
    search: {
      aggregator_name: '',
      merchant_name: '',
      mid: '',
      jenis_trx: '',
      trx_date: [],
    },
    editedItem: {
      aggregator_name: '',
      merchant_name: '',
      mid: '',
      trx_date: '',
    },
    // listQrType:listQrType,
    selectedRow: '',
    dateFormatted: '',
    dateMenu: false,
    editedIndex: -1,
  }),

  computed: {
    allData() {
      return this.$store.state.reportWalletTransactionStore.allData;
    },
    detailData() {
      return this.$store.state.reportWalletTransactionStore.item;
    },

    totalData() {
      return this.$store.state.reportWalletTransactionStore.totalData;
    },
    totalPage() {
      return this.$store.state.reportWalletTransactionStore.totalPage;
    },
    loading() {
      return this.$store.state.reportWalletTransactionStore.loading;
    },

    flashError: {
      get() {
        return this.$store.state.reportWalletTransactionStore.flashError;
      },
      set() {
        this.$store.commit('reportWalletTransactionStore/setFlashErrorMessage');
      },
    },
    flashErrorMessage() {
      return this.$store.state.reportWalletTransactionStore.flashErrorMessage;
    },
    dateRangeText() {
      return this.filter.trx_date.join(' ~ ');
    },
    minDate() {
      if (this.filter.trx_date.length > 0) {
        const tempMinDate = Date.parse(this.filter.trx_date[0]);
        return this.getDate(dataMinRangeDate, tempMinDate);
      }
      return '';
    },
    maxDate() {
      if (this.filter.trx_date.length > 0) {
        const tempMaxDate = Date.parse(this.filter.trx_date[0]);
        const maxDate = this.getDate(dataMaxRangeDate, tempMaxDate);
        return maxDate > this.today ? this.today : maxDate;
      }
      return this.today;
    },
  },

  watch: {
    options: {
      handler() {
        if (!this.isFirstLoad) {
          this.getData();
        } else {
          this.$store.commit('reportWalletTransactionStore/clearData');
        }
        this.isFirstLoad = false;
      },
      deep: true,
    },
  },

  methods: {
    checkRangeDate() {
      if (this.filter.trx_date.length == 1) {
        this.filter.trx_date.push(this.filter.trx_date[0]);
      }
    },

    selectRow(index) {
      if (this.selectedRow != index) {
        this.selectedRow = index;
      } else {
        this.selectedRow = '';
      }
    },

    rowClass() {
      const rowClass = 'max-width-col';
      return rowClass;
    },

    showData() {
      this.search.trx_date = this.filter.trx_date;
      this.getData();
    },

    getData() {
      if (this.filter.trx_date.length < 1) {
        this.$vuetify.goTo(0);
        showAlert(
          this.$store,
          'transaction date is required !',
          'mdi-alert',
          'red'
        );
        this.$store.commit('reportWalletTransactionStore/clearData');
      } else {
        this.$store.commit(
          'reportWalletTransactionStore/setFlashErrorMessage',
          ''
        );
        const { page, itemsPerPage, sortBy, sortDesc } = this.options;
        this.$store
          .dispatch('reportWalletTransactionStore/getData', {
            date,
            page,
            itemsPerPage,
            sortBy,
            sortDesc,
            search: this.search,
          })
          .then(() => {
            if (this.totalPage < page) {
              if (this.totalPage == 0) {
                this.options.page = 1;
              } else {
                this.options.page = this.totalPage;
              }
            }
          });
      }
    },

    async viewItem(itemId) {
      await this.$store
        .dispatch('reportWalletTransactionStore/getDetail', {
          trx_id: itemId,
          date,
        })
        .then(() => {
          if (!this.loading && this.detailData != null) {
            this.editedIndex = itemId;
          }
          this.editedItem = { ...this.detailData };
          this.view = true;
          this.editedIndex = -2;
          this.dialog = true;
        });
    },
    close() {
      this.view = false;
      this.dialog = false;
      this.$nextTick(() => {
        this.editedItem = { ...this.defaultItem };
        this.editedIndex = -1;
      });
    },

    closeFlash() {
      this.$store.commit(
        'reportWalletTransactionStore/setFlashErrorMessage',
        ''
      );
    },

    clearSearch() {
      this.search.aggregator_name = '';
      this.search.merchant_name = '';
      this.search.mid = '';
      this.search.trx_date = [];
    },

    formatDate(dateVal) {
      if (!dateVal) return null;

      const [year, month, day] = dateVal.split('-');
      return `${day}/${month}/${year}`;
    },
    parseDate(dateVal) {
      if (!dateVal) return null;

      const [day, month, year] = dateVal.split('/');
      return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`;
    },
    getDate,

    exportItem() {
      if (this.filter.trx_date.length < 1) {
        this.$vuetify.goTo(0);
        showAlert(
          this.$store,
          'transaction date is required !',
          'mdi-alert',
          'red'
        );
        this.$store.commit('reportWalletTransactionStore/clearData');
      } else {
        const { page, itemsPerPage, sortBy, sortDesc } = this.options;
        this.$store.dispatch('reportWalletTransactionStore/exportList', {
          date,
          page,
          itemsPerPage,
          sortBy,
          sortDesc,
          search: this.search,
        });
      }
    },
  },
};
</script>

<style>
.max-width-col td {
  white-space: nowrap;
  overflow: hidden;
  max-width: 250px;
  text-overflow: ellipsis;
}
.v-data-table .v-data-table__wrapper {
  height: 100%;
}
</style>
